import { DiagnosticFormData } from '../types/diagnostic';

const STORAGE_KEY = 'PENDING_DIAGNOSTIC_DATA';
const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

interface PendingDiagnosticData {
  formData: DiagnosticFormData;
  timestamp: number;
  redirectSource: 'results';
}

export function savePendingDiagnostic(formData: DiagnosticFormData): boolean {
  try {
    const data: PendingDiagnosticData = {
      formData,
      timestamp: Date.now(),
      redirectSource: 'results'
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Failed to save pending diagnostic to sessionStorage:', error);
    return false;
  }
}

export function getPendingDiagnostic(): DiagnosticFormData | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const data: PendingDiagnosticData = JSON.parse(stored);

    // Check if data has expired (older than 1 hour)
    if (Date.now() - data.timestamp > EXPIRATION_TIME) {
      cleanupPendingDiagnostic();
      return null;
    }

    return data.formData;
  } catch (error) {
    console.error('Failed to retrieve pending diagnostic from sessionStorage:', error);
    cleanupPendingDiagnostic();
    return null;
  }
}

export function hasPendingDiagnostic(): boolean {
  const diagnostic = getPendingDiagnostic();
  return diagnostic !== null;
}

export function cleanupPendingDiagnostic(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to cleanup pending diagnostic from sessionStorage:', error);
  }
}
